import axios from 'axios';
import { Action, createAction, handleActions } from 'redux-actions';
import { FULFILLED, PENDING, REJECTED } from './action-type.util';
import { ISite as IModel } from './site.model';
import {
    getAxiosData,
    getRejectedRespData,
    initPagingList,
    IPaging,
    parsePagingToParams,
    parseToPaging,
    SERVER_API_URL,
} from '../config/constants';
import { parseEmptyField } from '../shared/utils/utils';

export const ACTION_TYPES = {
    UPDATE_STATE: 'site/UPDATE_STATE',
    SET_PAGING: 'site/SET_PAGING',
    RESET_PAGING: 'site/RESET_PAGING',
    GET: 'site/GET',
    GET_LIST: 'site/GET_LIST',
    GET_BY_ID: 'site/GET_BY_ID',
    DELETE: 'site/DELETE',
    SAVE: 'site/SAVE',
};

export interface ISiteState {
    loading: boolean;
    error: any;
    list: IModel[];
    listShort: IModel[];
    data: IModel;
    paging: IPaging;
}

const initState = {
    loading: false,
    error: null,
    list: [],
    listShort: [],
    data: {} as IModel,
    paging: { ...initPagingList },
};

export const updateState = createAction(ACTION_TYPES.UPDATE_STATE);
export const setPaging = createAction(ACTION_TYPES.SET_PAGING);
export const resetPaging = createAction(ACTION_TYPES.RESET_PAGING);

export const get = createAction<any, any>(ACTION_TYPES.GET, (params?: any) =>
    getAxiosData(
        axios.get(`${SERVER_API_URL}/sites`, {
            params: parsePagingToParams({ ...initPagingList, ...params }),
        }),
    ),
);
export const getList = createAction(ACTION_TYPES.GET_LIST, () =>
    getAxiosData(axios.get(`${SERVER_API_URL}/sites/list`)),
);
export const getById = createAction(ACTION_TYPES.GET_BY_ID, (id: string) =>
    getAxiosData(axios.get(`${SERVER_API_URL}/sites/${id}`)),
);
export const remove = createAction(ACTION_TYPES.DELETE, async (id: string) => {
    await getAxiosData(axios.delete(`${SERVER_API_URL}/sites/${id}`));
    return id;
});
export const save = createAction(ACTION_TYPES.SAVE, (body: any) =>
    body.id
        ? getAxiosData(axios.put(`${SERVER_API_URL}/sites/${body.id}`, parseEmptyField(body)))
        : getAxiosData(axios.post(`${SERVER_API_URL}/sites`, parseEmptyField(body))),
);

/* Reducer function */
const onPending = (state: ISiteState): ISiteState => ({ ...state, loading: true });
// const onPendingCancel = (state: ISiteState): ISiteState => ({ ...state, loading: false });
const onRejected = (state: ISiteState, action: Action<any>): ISiteState => ({
    ...state,
    error: getRejectedRespData(action.payload),
    loading: false,
});
const onGetListShort = (state: ISiteState, action: Action<any[]>): ISiteState => ({
    ...state,
    loading: false,
    listShort: [...action.payload],
});
const onSetItem = (state: ISiteState, action: Action<any>): ISiteState => ({
    ...state,
    loading: false,
    data: { ...action.payload },
});
/* Reducer function end */

export default handleActions<ISiteState, any>(
    {
        [ACTION_TYPES.UPDATE_STATE]: (state: ISiteState, action: Action<any>): ISiteState => ({
            ...state,
            ...action.payload,
        }),
        [ACTION_TYPES.SET_PAGING]: (state: ISiteState, action: Action<IPaging>): ISiteState => ({
            ...state,
            paging: { ...state.paging, ...parseToPaging(action.payload) },
        }),
        [ACTION_TYPES.RESET_PAGING]: (state: ISiteState): ISiteState => ({
            ...state,
            paging: { ...initPagingList },
        }),

        [PENDING(ACTION_TYPES.GET)]: onPending,
        [REJECTED(ACTION_TYPES.GET)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET)]: (state: ISiteState, action: Action<any>): ISiteState => {
            const { page: list = [], ...paging } = action.payload;
            return { ...state, loading: false, list, paging: { ...state.paging, ...paging } };
        },

        [PENDING(ACTION_TYPES.GET_BY_ID)]: onPending,
        [REJECTED(ACTION_TYPES.GET_BY_ID)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET_BY_ID)]: onSetItem,

        [PENDING(ACTION_TYPES.GET_LIST)]: onPending,
        [REJECTED(ACTION_TYPES.GET_LIST)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET_LIST)]: onGetListShort,

        [PENDING(ACTION_TYPES.DELETE)]: onPending,
        [REJECTED(ACTION_TYPES.DELETE)]: onRejected,
        [FULFILLED(ACTION_TYPES.DELETE)]: (state: ISiteState, action: Action<any>): ISiteState => ({
            ...state,
            loading: false,
            list: state.list.filter((el: IModel) => el.id !== action.payload),
            listShort: state.listShort.filter((el: IModel) => el.id !== action.payload),
        }),

        [PENDING(ACTION_TYPES.SAVE)]: onPending,
        [REJECTED(ACTION_TYPES.SAVE)]: onRejected,
        [FULFILLED(ACTION_TYPES.SAVE)]: onSetItem,

        /* WS events */
        /* WS events end */
    },
    initState,
);
